import { render } from "./UsernameField.vue?vue&type=template&id=09db1aae&scoped=true"
import script from "./UsernameField.vue?vue&type=script&lang=js"
export * from "./UsernameField.vue?vue&type=script&lang=js"

import "./UsernameField.vue?vue&type=style&index=0&id=09db1aae&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09db1aae"]])

export default __exports__